import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import type { WabaPhoneNumber } from '@/types'

interface WabaState {
  wabaList: WabaPhoneNumber[]
  selectedWabaId: string | null
  defaultWabaId: string | null
  hasWaba: boolean
  isLoading: boolean

  setWabaData: (list: WabaPhoneNumber[], defaultId: string | null, hasWaba: boolean) => void
  selectWaba: (wabaId: string) => void
  getSelectedWaba: () => WabaPhoneNumber | undefined
  reset: () => void
}

export const useWabaStore = create<WabaState>()(
  persist(
    (set, get) => ({
      wabaList: [],
      selectedWabaId: null,
      defaultWabaId: null,
      hasWaba: false,
      isLoading: false,

      setWabaData: (list, defaultId, hasWaba) => {
        const currentSelected = get().selectedWabaId
        // Compare as strings since backend IDs are numbers
        const selectedId = currentSelected && list.find((w) => String(w.id) === currentSelected)
          ? currentSelected
          : defaultId ? String(defaultId) : (list.length > 0 ? String(list[0].id) : null)

        set({
          wabaList: list,
          defaultWabaId: defaultId ? String(defaultId) : null,
          hasWaba,
          selectedWabaId: selectedId,
        })
      },

      selectWaba: (wabaId) => {
        set({ selectedWabaId: wabaId })
      },

      getSelectedWaba: () => {
        const { wabaList, selectedWabaId } = get()
        return wabaList.find((w) => String(w.id) === selectedWabaId)
      },

      reset: () => {
        set({
          wabaList: [],
          selectedWabaId: null,
          defaultWabaId: null,
          hasWaba: false,
        })
      },
    }),
    {
      name: 'waba-store',
      partialize: (state) => ({
        selectedWabaId: state.selectedWabaId,
        defaultWabaId: state.defaultWabaId,
        hasWaba: state.hasWaba,
        wabaList: state.wabaList,
      }),
    },
  ),
)
